<div class="login-container row">
  <aside class="col-lg-5 col-12 left-section">
    <div class="brand">
      <img src="assets/images/bas-logo.svg" class="brand-logo" alt="BAS" width="100" height="100" />
      <h2 class="brand-title">Biometric Authentication System</h2>
      <p class="brand-desc">
        Enroll every associate and workforce member joining through manpower agencies, and verify their
        eligibility.
      </p>
      <img src="assets/images/bas-login-img.svg" class="brand-illustration" alt="" aria-hidden="true" />
    </div>
  </aside>

  <main class="col-lg-7 col-12 login-wrapper">
    <div class="ambient" aria-hidden="true">
      <span class="glow glow-a"></span>
      <span class="glow glow-b"></span>
    </div>
    <div class="login-card">
      <header class="login-header">
        <h1 class="form-title">Login to BAS</h1>
        <p class="login-info">Enter your registered mobile number and password.</p>
      </header>

      <form class="login-form" [formGroup]="loginForm" (ngSubmit)="onLogin()" novalidate>
        <div class="field">
          <label class="field-label" for="login-mobile">Mobile number</label>
          <input id="login-mobile" class="field-input" type="tel" inputmode="numeric" formControlName="mobile"
            placeholder="10-digit mobile number" autocomplete="username" maxlength="10"
            [class.invalid]="showError('mobile')" [attr.aria-invalid]="showError('mobile')"
            aria-describedby="login-mobile-error" required />
          <p id="login-mobile-error" class="field-error" role="alert">
            @if (showError('mobile')) {
              {{ loginForm.get('mobile').hasError('required') ? 'Enter your mobile number' : 'Enter a valid 10-digit mobile number' }}
            }
          </p>
        </div>

        <div class="field">
          <div class="field-label-row">
            <label class="field-label" for="login-password">Password</label>
            <button type="button" class="link-btn small" (click)="openDialog()">Forgot password?</button>
          </div>
          <div class="password-group" [class.invalid]="showError('password')">
            <input id="login-password" class="field-input" formControlName="password"
              [type]="showPassword ? 'text' : 'password'" placeholder="Enter your password"
              autocomplete="current-password" maxlength="20" [attr.aria-invalid]="showError('password')"
              aria-describedby="login-password-error" required />
            <button type="button" class="toggle-password" (click)="toggleInputType()"
              [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'" [attr.aria-pressed]="showPassword">
              <img [src]="showPassword ? 'assets/images/hide-password-icon.svg' : 'assets/images/show-password-icon.svg'"
                alt="" aria-hidden="true" />
            </button>
          </div>
          <p id="login-password-error" class="field-error" role="alert">
            @if (showError('password')) {
              {{ loginForm.get('password').hasError('required') ? 'Enter your password' : 'Password must be at least 10 characters' }}
            }
          </p>
        </div>

        <!-- Cloudflare Turnstile managed widget -->
        <div class="turnstile-wrap">
          <div #turnstile class="turnstile"></div>
          <p class="field-error center" role="alert">
            @if (captchaMessage) {
              {{ captchaMessage }}
            }
          </p>
        </div>

        <div class="consent">
          <input id="login-consent" type="checkbox" formControlName="checkbox"
            [attr.aria-invalid]="showError('checkbox')" aria-describedby="login-consent-error" />
          <label for="login-consent">I agree to the</label>
          <button type="button" class="link-btn" (click)="filterPopUp('')">Privacy Policy</button>
        </div>
        <p id="login-consent-error" class="field-error" role="alert">
          @if (showError('checkbox')) {
            Please accept the Privacy Policy to continue
          }
        </p>

        <button type="submit" class="login-submit" [disabled]="submitting" [attr.aria-busy]="submitting">
          @if (submitting) {
            <span class="spinner" aria-hidden="true"></span>
            <span>Signing in…</span>
          } @else {
            <span>Login</span>
          }
        </button>
      </form>
    </div>
  </main>
</div>
